import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { RegistrationDetailsOdinRefresh } from '@/common/viewModels';
import { RegistrationsDetailsFormStateNewCloudAccount } from '@/common/viewModels/registrationDetails/form/state/RegistrationDetailsFormStateNewCloudAccount';
import { RegistrationDetailsFormDataNewCloudAccount } from '@/common/viewModels/registrationDetails/form/data/RegistrationDetailsFormDataNewCloudAccount';
import { RegistrationDetailsFormLookups } from '@/common/viewModels/registrationDetails/form/RegistrationDetailsFormLookups';
import { Button } from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    Button,
  },
})
export default class RegistrationDetailsNewCloudAccount extends Vue {
  @Prop({ required: true }) data!: RegistrationDetailsFormDataNewCloudAccount;
  @Prop({ required: true }) state!: RegistrationsDetailsFormStateNewCloudAccount;
  @Prop({ required: true }) odinDataRefresh!: RegistrationDetailsOdinRefresh;
  @Prop({ required: true }) lookups!: RegistrationDetailsFormLookups;
  @Prop() testing!: boolean;

  mounted(): void {
    this._initialiseVForm();
  }

  @Emit()
  formInputChange(inputEvent: any) {
    const target: any = inputEvent.target;
    this.$emit('formInputChange', target.name, target.value);
  }

  @Emit()
  getOdinDataClicked() {
    if (!this.odinDataRefresh.isDisabled) {
      this.$emit('getOdinDataClicked');
    }
  }

  private _initialiseVForm() {
    if (this.testing !== true) {
      (this.$refs.vForm as any).validate();
    }
  }
}
